import React from "react";
import {
  DisableHelenaActivationQuestionType,
  EnableHelenaType,
} from "store/types/helena.types";
import { User } from "model/user.model";
import { GlobalState } from "store/configure-store";
import { selectUser } from "store/reducers/user-context.reducer";
import { connect } from "react-redux";
import {
  disableHelenaActivationQuestion,
  enableHelena,
} from "store/actions/helena.actions";
import { useTranslation } from "react-i18next";
import { Alert, Button, Col, Icon, Row } from "@cc/react-components";

export interface Props {
  messageKey?: string;
}

const HelenaUserRegistrationCard = ({
  user,
  enableHelena,
  disableHelenaActivationQuestion,
  messageKey,
}: StateFromProps & DispatchFromProps & Props) => {
  const [t] = useTranslation();

  const renderHelenaNotEnabled = () => {
    return (
      <>
        <Alert variant="info">
          <Row>
            <Col xs={10}>
              {t(!!messageKey ? messageKey : "helena.user.medicationInfo")}
            </Col>

            <Col xs={1} className={"d-flex align-items-center"}>
              <a
                href={t("helena.manual")}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon type="info" size="2x" />
              </a>
            </Col>
          </Row>
        </Alert>

        <Row className={"pt-3"}>
          <Col xs={12} className={"pb-2"}>
            <Button
              block
              variant="primary"
              onClick={() => enableHelena(user.id)}
            >
              {t("helena.user.enable")}
            </Button>
          </Col>
          <Col xs={12}>
            <Button
              block
              variant="primary"
              onClick={() => disableHelenaActivationQuestion(user.id)}
            >
              {t("helena.user.disable")}
            </Button>
          </Col>
        </Row>
      </>
    );
  };

  return <React.Fragment>{renderHelenaNotEnabled()}</React.Fragment>;
};

interface StateFromProps {
  user: User;
}

interface DispatchFromProps {
  enableHelena: EnableHelenaType;
  disableHelenaActivationQuestion: DisableHelenaActivationQuestionType;
}

const mapStateToProps = (state: GlobalState) => {
  return {
    user: selectUser(state),
  };
};

export default connect(mapStateToProps, {
  enableHelena,
  disableHelenaActivationQuestion,
})(HelenaUserRegistrationCard);
